/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import Card from "../Card"; // Custom Card component for displaying NFT information
// Importing images used as placeholders and decorative elements
import card_top_img from "../../../../assets/images/card_top-box.svg";


const TopFund = ({ data, previewCard }) => {

  // Placeholder data for cards, in case `previewCard` is empty
  const placeholderCards = [
    {
      name: data.nft_name ? data.nft_name : 'NFT', // If data.nft_name is not available, default to 'NFT'
      price: 0,
      image: card_top_img, // Image for placeholder cards
      tokenId: 1,
      siteTokenIndex: 1,
      forSale: true,
      originalPrice: 0,
      address: "0xB50041BCb2284A6f5Febec3EB82ebBc62471beaC",
    },
    {
      name: data.nft_name ? data.nft_name : 'NFT',
      price: 0,
      image: card_top_img,
      tokenId: 1,
      siteTokenIndex: 1,
      forSale: false,
      originalPrice: 0,
      address: "0xB50041BCb2284A6f5Febec3EB82ebBc62471beaC",
    },
    {
      name: data.nft_name ? data.nft_name : 'NFT',
      price: 0,
      image: card_top_img,
      tokenId: 1,
      siteTokenIndex: 1,
      forSale: false,
      originalPrice: 0,
      address: "0xB50041BCb2284A6f5Febec3EB82ebBc62471beaC",
    }
  ];

  // Determine the number of cards to display, limited to 3 or the number of available preview cards
  let loopLength = previewCard.length < 3 ? previewCard.length : 3;

  // Function to render the NFT cards (placeholder or actual preview cards based on availability)
  const renderCardData = () => {
    return (
      <>
        {previewCard.length === 0 ? (
          // Display placeholder cards if preview cards are unavailable
          <>
            {placeholderCards.map((card, index) => (
              <div className="topfund-card-wrapper" key={index}>
                <Card
                  card={card}
                  btn="Buy"
                  download={false}
                  overlay={false}
                  overlayText={false}
                />
              </div>
            ))}
          </>
        ) : (
          // Display actual preview cards if available
          <>
            {previewCard.slice(0, loopLength).map((card, index) => (
              <div className="topfund-card-wrapper" key={index}>
                <Card
                  card={card}
                  btn="Buy"
                  download={false}
                  overlay={false}
                  overlayText={false}
                />
              </div>
            ))}
          </>
        )}
      </>
    );
  };

  return (
    <>
      {/* Anchor link for smooth navigation to top of section */}
      <span className="link_wrapper" id="top"></span>

      {/* Main section for displaying Top Fundraisers */}
      <section
        id="topfund"
        className="default-settings gradient-bg"
        style={{
          // Gradient background styling with colors from props
          backgroundImage: `linear-gradient(
            ${data.gradient_color_1},
            ${data.gradient_color_2}
          )`,
          backgroundPosition: "center center",
        }}
      >

        {/* Section title and icon */}
        <div className="topfund__title-box">
          <div className="topfund__title-box-group">
            <h1 className="topfund__title-text" style={{ color: data.light_text_color }}>Top</h1>
          </div>
          &nbsp; &nbsp; &nbsp;
          <h1 className="topfund__title-text" style={{ color: data.light_text_color }}>Fundraisers</h1>
        </div>

        <p className="topfund__desc" style={{ color: data.light_text_color }}>
          {data.ct_about_top_fundraisers}
        </p>
        { /* Container for NFT cards */}
        <div className="topfund-cards">
          {renderCardData()}
        </div>
      </section>
    </>
  );
};

export default TopFund;
